// extracted by mini-css-extract-plugin
export default {"column":"SignUpbyMail_column__EAFTX","wrapper":"SignUpbyMail_wrapper__4V7oy","text":"SignUpbyMail_text__BOBbo"};